/**
 * Wire constants mirrored from `@windrop/contracts` so the initial bundle stays free of the contracts runtime
 * (zod + every schema). `src/lib/contracts-parity.test.ts` asserts these never drift from the package.
 * Feature chunks may import the contracts runtime freely (they are lazy and outside the landing budget).
 */
export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';
export const PROBLEM_CONTENT_TYPE = 'application/problem+json';
export const PROBLEM_TYPE_BASE = 'https://windrop.dev/problems/';

/** `CLIENT_EMITTABLE_TOPICS` (§19): the only topics a browser may send to `POST /v1/analytics/events`. */
export const CLIENT_TOPICS = [
  'lottery_viewed',
  'rules_expanded',
  'entry_started',
  'reveal_presented',
  'reveal_skipped',
  'sponsor_impression',
  'message_button_tapped',
] as const;
export type ClientTopic = (typeof CLIENT_TOPICS)[number];
